import config from '@/utils/config'
import {
  CSRF_TOKEN_HEADER,
  getCsrfToken,
  isInternalRequest,
} from '@/utils/csrfToken'

const RAILS_DOMAIN = config('RAILS_DOMAIN')

// Same base the shared axios instance uses (src/utils/AxiosService.js). Needed
// as the origin gate's reference below: this page is served from reports.*, so
// comparing the upload URL against `window.location.origin` would reject it.
const RAILS_BASE_URL = `https://${RAILS_DOMAIN}/`

export const froalaOptions = {
  key: 'hWA2C-7I2C4C1B4E4D1A2wd1DBKSPF1WKTUCQOa1OURPJ1KDe2F-11D2C2D2E2C3B3D2D6D1F1==',
  attribution: false,
  pastePlain: true,
  useClasses: true,
  placeholderText: 'Enter text here',
  charCounterCount: false,
  videoResponsive: true,
  toolbarButtons: [
    'inlineStyle',
    'bold',
    'italic',
    'underline',
    'textColor',
    'backgroundColor',
    '|',
    'formatOL',
    'formatUL',
    '|',
    'align',
    'insertLink',
    'insertImage',
    'insertVideo',
    'insertTable',
    '|',
    'html',
    'clearFormatting',
  ],
  toolbarButtonsMD: [
    'inlineStyle',
    'bold',
    'italic',
    'underline',
    'textColor',
    'backgroundColor',
    '|',
    'align',
    'insertLink',
    'insertImage',
    'insertVideo',
    'insertTable',
    '|',
    'html',
    'clearFormatting',
  ],
  toolbarButtonsSM: [
    'inlineStyle',
    'bold',
    'italic',
    'underline',
    'textColor',
    'backgroundColor',
    '|',
    'align',
    'insertLink',
    'insertImage',
    'insertVideo',
    'insertTable',
    '|',
    'html',
    'clearFormatting',
  ],
  toolbarButtonsXS: [
    'inlineStyle',
    'bold',
    'italic',
    'underline',
    'textColor',
    'backgroundColor',
    '|',
    'align',
    'insertLink',
    'insertImage',
    'insertVideo',
    'insertTable',
    '|',
    'html',
    'clearFormatting',
  ],

  colorsText: [
    '#000000',
    '#222222',
    '#555555',
    '#888888',
    '#aaaaaa',
    '#dddddd',
    '#ffffff',
    '#d53636',
    '#f9890e',
    '#e5e318',
    '#65c635',
    '#5c9ccf',
    '#731eb5',
    'REMOVE',
  ],
  colorsBackground: [
    '#000000',
    '#222222',
    '#555555',
    '#888888',
    '#aaaaaa',
    '#dddddd',
    '#ffffff',
    '#d53636',
    '#f9890e',
    '#e5e318',
    '#65c635',
    '#5c9ccf',
    '#731eb5',
    'REMOVE',
  ],
  inlineStyles: {
    XLarge: 'font-size:2rem; color: inherit; line-height:2.25rem;',
    Large: 'font-size:1.5rem; color:inherit; line-height:1.7rem;',
    Normal: 'font-size:1rem; color: inherit; line-height: 1.2rem',
    Small: 'font-size: .8rem; line-height:1rem;',
    Light: 'color: #aaaaaa;',
    'Small/Light': 'font-size: .8rem; line-height:1rem; color: #aaaaaa;',
  },
  quickInsertButtons: ['ul', 'ol', 'hr'],
  pluginsEnabled: [
    'draggable',
    'align',
    'lineBreaker',
    'lists',
    'colors',
    'link',
    'image',
    'video',
    'table',
    'inlineStyle',
    'paragraphFormat',
    'paragraphStyle',
    'codeMirror',
    'codeView',
  ],
  height: 200,
  // Keep toolbar in document flow so it stays inside modals/scrollable containers
  toolbarSticky: false,
  imageUploadURL: `https://${RAILS_DOMAIN}/editor_assets`,
  // PLT-2110: send the Devise session cookie with the upload. This is a cross-origin
  // XHR (reports.spectora.com -> app.spectora.com), so without credentials Rails sees an
  // unauthenticated request — and /editor_assets now rejects those with 401. The server
  // already allows it: rack-cors answers *.spectora.com with Allow-Credentials: true.
  requestWithCredentials: true,
  linkInsertButtons: ['linkBack'],
  videoInsertButtons: ['videoByURL', 'videoEmbed'],
  imageDefaultAlign: 'left',
  imageDefaultDisplay: 'inline',
  imageDefaultWidth: 200,
  imageEditButtons: [
    'imageAlign',
    'imageDisplay',
    'imageStyle',
    '-',
    'imageCaption',
    'imageAlt',
    'imageRemove',
    '-',
    'imageLink',
    'linkOpen',
    'linkEdit',
    'linkRemove',
  ],
  imageStyles: {
    circle: 'Circle',
    bordered: 'Border',
    shadowed: 'Shadow',
    margin: 'Margin',
    'padding-left': 'Padding Left',
    'padding-right': 'Padding Right',
  },
}

export const froalaOptionsSimple = Object.assign(
  JSON.parse(JSON.stringify(froalaOptions)),
  {
    toolbarButtons: [
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'formatOL',
      'formatUL',
      '|',
      'insertLink',
      'insertImage',
      'insertVideo',
      'insertTable',
      '|',
      'html',
      'clearFormatting',
    ],
    toolbarButtonsMD: [
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'formatOL',
      'formatUL',
      '|',
      'insertLink',
      'insertImage',
      'insertVideo',
      'insertTable',
      '|',
      'html',
      'clearFormatting',
    ],
    toolbarButtonsSM: [
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'insertLink',
      'insertVideo',
      '|',
      'html',
      'clearFormatting',
    ],
    toolbarButtonsXS: [
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'insertLink',
      'insertVideo',
      '|',
      'html',
      'clearFormatting',
    ],
  }
)

export const froalaOptionsAdvanced = Object.assign(
  JSON.parse(JSON.stringify(froalaOptions)),
  {
    imageEditButtons: [
      'imageReplace',
      'imageAlign',
      'imageRemove',
      '|',
      'imageLink',
      'linkOpen',
      'linkEdit',
      'linkRemove',
      '-',
      'imageDisplay',
      'imageStyle',
      'imageAlt',
      'imageSize',
    ],
    toolbarButtons: [
      'paragraphFormat',
      'paragraphStyle',
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'formatOL',
      'formatUL',
      '|',
      'align',
      'insertLink',
      'insertImage',
      'insertVideo',
      'insertTable',
      '|',
      'html',
      'clearFormatting',
    ],
    toolbarButtonsMD: [
      'paragraphFormat',
      'paragraphStyle',
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'align',
      'insertLink',
      'insertImage',
      'insertVideo',
      'insertTable',
      '|',
      'html',
      'clearFormatting',
    ],
    toolbarButtonsSM: [
      'paragraphFormat',
      'paragraphStyle',
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'align',
      'insertLink',
      'insertImage',
      'insertVideo',
      'insertTable',
      '|',
      'html',
      'clearFormatting',
    ],
    toolbarButtonsXS: [
      'paragraphFormat',
      'paragraphStyle',
      'inlineStyle',
      'bold',
      'italic',
      'underline',
      'textColor',
      'backgroundColor',
      '|',
      'align',
      'insertLink',
      'insertImage',
      'insertVideo',
      'insertTable',
      '|',
      'html',
      'clearFormatting',
    ],
  }
)

const bare = JSON.parse(JSON.stringify(froalaOptionsSimple))
const bareOptions = [
  'toolbarButtons',
  'toolbarButtonsMD',
  'toolbarButtonsSM',
  'toolbarButtonsXS',
  'quickInsertButtons',
  'pluginsEnabled',
  'linkInsertButtons',
  'videoInsertButtons',
  'imageEditButtons',
]
for (let i = 0; i < bareOptions.length; i++) {
  bare[bareOptions[i]] = []
}

export const froalaOptionsBare = bare

/**
 * PLT-2103 — carry the session CSRF token on Froala's image upload.
 *
 * `POST /editor_assets` is a cookie-authenticated write: the upload is
 * cross-origin (reports.* -> the Rails host) and PLT-2110 gave it
 * `requestWithCredentials: true`, so the Devise session rides along. Once
 * PLT-2105 turns verification on, a tokenless upload is rejected — and under
 * its `:null_session` strategy that rejection is **silent**: PLT-2110's guard
 * answers `401 {"link": null}`, which Froala swallows, so the image simply
 * never inserts with no user-visible error.
 *
 * None of `AxiosService.js`'s interceptors reach this path. Froala builds its
 * own `XMLHttpRequest` and applies `opts.requestHeaders` to it, so the token
 * has to be put there instead.
 *
 * **Read the token inside the handler, never at module scope.** The holder in
 * `csrfToken.js` is `null` until the first Rails response lands, and every
 * option object in this file is built at import time. `image.beforeUpload`
 * fires before the XHR is built, and Froala re-reads `opts.requestHeaders` per
 * request, so assigning here is what makes a live value reach the wire.
 */
export const attachCsrfUploadHeader = function () {
  const opts = this && this.opts
  if (!opts) return

  const token = getCsrfToken()
  if (!token) return

  // The gate takes RAILS_BASE_URL explicitly: `imageUploadURL` is absolute at
  // the Rails host while the page origin is reports.*, so the default
  // window-origin comparison would reject our own upload.
  if (!isInternalRequest(opts.imageUploadURL, RAILS_BASE_URL)) return

  opts.requestHeaders = {
    ...opts.requestHeaders,
    [CSRF_TOKEN_HEADER]: token,
  }
}

/**
 * Attaches the handler to one config object, preserving whatever was there.
 *
 * **Every exported config has to be passed through this individually.** The
 * derived configs in this file are JSON deep-clones —
 * `Object.assign(JSON.parse(JSON.stringify(froalaOptions)), …)` for Simple and
 * Advanced, `JSON.parse(JSON.stringify(froalaOptionsSimple))` for Bare — and
 * `JSON.stringify` drops functions. So attaching to `froalaOptions` alone
 * reaches none of them, and every component in this app imports a derived
 * config rather than the base.
 */
export const withCsrfUploadHeader = (options) => {
  const existing = options.events && options.events['image.beforeUpload']

  options.events = {
    ...options.events,
    'image.beforeUpload': function (...args) {
      attachCsrfUploadHeader.call(this)

      // Preserve an existing handler's veto — Froala cancels the upload when
      // `image.beforeUpload` returns false.
      return existing ? existing.apply(this, args) : undefined
    },
  }

  return options
}

// Four separate attachments, not one inherited four times: each config is an
// independent object by the time we get here (see withCsrfUploadHeader).
//
// A `forEach` statement rather than an exported `.map`, deliberately. This is a
// mutation performed for its side effect at import time, and nothing consumes a
// return value — so an exported binding would be dead surface area, and its
// deadness is what would let a bundler decide the call is removable. A bare
// statement is unambiguous.
;[
  froalaOptions,
  froalaOptionsSimple,
  froalaOptionsAdvanced,
  froalaOptionsBare,
].forEach(withCsrfUploadHeader)
